<div class="col-xs-12">
  <div class="btn-group">
    <div class="btn btn-default btn-sm btn-action" ng-click="cadastroColheita.goToIndex()">Voltar</div>
    <div class="btn btn-primary btn-sm btn-action" ng-click="cadastroColheita.edit()" ng-if="permissions.colheitas.canManage">
      Editar<i class="glyphicon glyphicon-pencil"></i>
    </div>
    <div class="btn btn-danger btn-sm btn-action" ng-click="cadastroColheita.delete()" ng-if="permissions.colheitas.canManage">
      Excluir <i class="glyphicon glyphicon-trash"></i>
    </div>
  </div>
</div>
